// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file Enumerations/IdentityUserSortBy.proto (package time_tracking.enumerations, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc } from "@bufbuild/protobuf/codegenv2";
import { file_Options_EnumValueOptions } from "../Options/EnumValueOptions_pb";

/**
 * Describes the file Enumerations/IdentityUserSortBy.proto.
 */
export const file_Enumerations_IdentityUserSortBy: GenFile = /*@__PURE__*/
  fileDesc("CiVFbnVtZXJhdGlvbnMvSWRlbnRpdHlVc2VyU29ydEJ5LnByb3RvEhp0aW1lX3RyYWNraW5nLmVudW1lcmF0aW9ucyqbBAoSSWRlbnRpdHlVc2VyU29ydEJ5EiUKIUlERU5USVRZX1VTRVJfU09SVF9CWV9VTlNQRUNJRklFRBAAEisKH0lERU5USVRZX1VTRVJfU09SVF9CWV9URU5BTlRfSUQQAxoGysfNDwEDEicKG0lERU5USVRZX1VTRVJfU09SVF9CWV9FTUFJTBAEGgbKx80PAQQSMQolSURFTlRJVFlfVVNFUl9TT1JUX0JZX0VNQUlMX0NPTkZJUk1FRBAFGgbKx80PAQUSKwofSURFTlRJVFlfVVNFUl9TT1JUX0JZX1VTRVJfTkFNRRAGGgbKx80PAQYSLAogSURFTlRJVFlfVVNFUl9TT1JUX0JZX0ZJUlNUX05BTUUQBxoGysfNDwEHEisKH0lERU5USVRZX1VTRVJfU09SVF9CWV9MQVNUX05BTUUQCBoGysfNDwEIEi0KIUlERU5USVRZX1VTRVJfU09SVF9CWV9ST0xFU19DT1VOVBAJGgbKx80PAQkSLQogSURFTlRJVFlfVVNFUl9TT1JUX0JZX0NSRUFURURfQVQQZBoHysfNDwJkARIuCiFJREVOVElUWV9VU0VSX1NPUlRfQllfTU9ESUZJRURfQVQQZRoHysfNDwJkAhItCiBJREVOVElUWV9VU0VSX1NPUlRfQllfREVMRVRFRF9BVBBmGgfKx80PAmQDIgQIARABIgQIAhACIgQIChBjQiiqAiVNb2dpLlRpbWVUcmFja2luZy5Db21tb24uRW51bWVyYXRpb25zYgZwcm90bzM", [file_Options_EnumValueOptions]);

/**
 * Determines by which colums to sort Identity users by.
 *
 * @generated from enum time_tracking.enumerations.IdentityUserSortBy
 */
export enum IdentityUserSortBy {
  /**
   * Do not apply any specific sorting to the query.
   *
   * @generated from enum value: IDENTITY_USER_SORT_BY_UNSPECIFIED = 0;
   */
  UNSPECIFIED = 0,

  /**
   * Sort the users by their tenant id.
   *
   * @generated from enum value: IDENTITY_USER_SORT_BY_TENANT_ID = 3;
   */
  TENANT_ID = 3,

  /**
   * Sort the users by their email address.
   *
   * @generated from enum value: IDENTITY_USER_SORT_BY_EMAIL = 4;
   */
  EMAIL = 4,

  /**
   * Sort the users by whether they have a confirmed email address or not.
   *
   * @generated from enum value: IDENTITY_USER_SORT_BY_EMAIL_CONFIRMED = 5;
   */
  EMAIL_CONFIRMED = 5,

  /**
   * Sort the users by their user name (which usually is the same as the email address).
   *
   * @generated from enum value: IDENTITY_USER_SORT_BY_USER_NAME = 6;
   */
  USER_NAME = 6,

  /**
   * Sort the users by their first name.
   *
   * @generated from enum value: IDENTITY_USER_SORT_BY_FIRST_NAME = 7;
   */
  FIRST_NAME = 7,

  /**
   * Sort the users by their last name.
   *
   * @generated from enum value: IDENTITY_USER_SORT_BY_LAST_NAME = 8;
   */
  LAST_NAME = 8,

  /**
   * Sort the users by the number of roles they are assigned to.
   *
   * @generated from enum value: IDENTITY_USER_SORT_BY_ROLES_COUNT = 9;
   */
  ROLES_COUNT = 9,

  /**
   * Sort the users by their creation time stamp.
   *
   * @generated from enum value: IDENTITY_USER_SORT_BY_CREATED_AT = 100;
   */
  CREATED_AT = 100,

  /**
   * Sort the users by their modification time stamp.
   *
   * @generated from enum value: IDENTITY_USER_SORT_BY_MODIFIED_AT = 101;
   */
  MODIFIED_AT = 101,

  /**
   * Sort the users by their deletion time stamp.
   *
   * @generated from enum value: IDENTITY_USER_SORT_BY_DELETED_AT = 102;
   */
  DELETED_AT = 102,
}

/**
 * Describes the enum time_tracking.enumerations.IdentityUserSortBy.
 */
export const IdentityUserSortBySchema: GenEnum<IdentityUserSortBy> = /*@__PURE__*/
  enumDesc(file_Enumerations_IdentityUserSortBy, 0);

